const Education = () => {
    return ( 
        <div className="col s12 mt-5 py-3" id="edu">
            <div className="row">
                <div className="col s12 m6 l4 mb-5">
                    <div className="video-container" controls>
                        <iframe title="HEXCO EngineeringMaths 3 - Variation of Parameters method : 2nd-order Nonhomogeneous Diff Equations" src="https://www.youtube.com/embed/auhDf5HV3QI" frameBorder="0" allowFullScreen={true} ></iframe>
                    </div>
                </div>
                <div className="col s12 m6 l4 mb-5">
                    <div className="video-container" controls>
                        <iframe title="HEXCO EngMaths3-Method of Undetermined Coefficients" src="https://www.youtube.com/embed/RFsZFF0Mq78" frameBorder="0" allowFullScreen={true} ></iframe>
                    </div>
                </div>
                <div className="col s12 m6 l4 mb-5">
                    <div className="video-container" controls>
                        <iframe title="HEXCO EngMaths1-Trig Equations involving double angle identities" src="https://www.youtube.com/embed/8iN3K5vzwqw" frameBorder="0" allowFullScreen={true} ></iframe>
                    </div>
                </div>
                <div className="col s12 m6 l4 mb-5">
                    <div className="video-container" controls>
                        <iframe title="HEXCO Engineering Mathematics3" src="https://www.youtube.com/embed/i5RBdIW42Aw" frameBorder="0" allowFullScreen={true} ></iframe>
                    </div>
                </div>
                <div className="col s12 m6 l4 mb-5">
                    <div className="video-container" controls>
                        <iframe title="HEXCO Engineering Mathematics 3 - Differential Equations : Method of Undetermined Coefficients ." src="https://www.youtube.com/embed/YyLn3ExSXh4" frameBorder="0" allowFullScreen={true} ></iframe>
                    </div>
                </div>
            </div>
        </div>
     );
}
 
export default Education;